import {action, makeObservable, observable} from 'mobx';
import BaseModel from './BaseModel';

export default class User extends BaseModel {

  constructor(store) {
    super(store);
    
     makeObservable(this, {
       id: observable,
       telegram_id: observable,
       fio: observable,
       first_name: observable,
       last_name: observable,
       username: observable,
       is_admin: observable,
       companies: observable,
       language: observable,
       country_id: observable,
       region_id: observable,
       district_id: observable,
       lat: observable,
       lon: observable,
     });
  }

  id = 0;
  telegram_id = '';
  fio = '';
  first_name = '';
  last_name = '';
  username = '';
  language = 'ru';
  country_id = '';
  region_id = '';
  district_id = '';
  country = {};
  region = {};
  district = {};
  lat = 0;
  lon = 0;
  is_admin = false;
  companies = [];
}
